import { useEffect, useRef } from 'react';

// Utility helper for random number generation
export const random = (min: number, max: number) => Math.floor(Math.random() * (max - min)) + min;

const useRandomInterval = (callback: () => void, minDelay: number, maxDelay: number) => {
    const timeoutId = useRef<NodeJS.Timeout>(null);
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const handleTick = () => {
            const nextTickAt = random(minDelay, maxDelay);
            timeoutId.current = setTimeout(() => {
                savedCallback.current();
                handleTick();
            }, nextTickAt);
        };
        handleTick();
        return () => clearTimeout(timeoutId.current);
    }, [minDelay, maxDelay]);
};

export default useRandomInterval;
